import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import App from './App';
import Landing from './pages/Landing';
import CvAnalyserPage from './pages/CvAnalyserPage';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/cv" element={<CvAnalyserPage />} />
        <Route path="/app/*" element={<App />} />
        <Route path="/login" element={<Navigate to="/app" replace />} />
        <Route path="/signup" element={<Navigate to="/app" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
